/* Forms - File Dropzone - Image */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsFileDropZoneImage(dropzone, image) {
    //console.log(image);
    if (typeof (image) !== 'undefined' && image != 'NULL' && image) {
        /* Check Correct Type */
        if (dropzone.parent().hasClass('form-file-alt')) {

            /* Remove Previous Image */
            dropzone.find('.form-file-image').remove();

            var div = '<div class="form-file-image" data-logo="' + image + '"><img src="/media/ims/forms/image-placeholder.gif"></div>';

            /* Add Image */
            dropzone.prepend(div);
            dropzone.find('.form-file-image').css("background-image", 'url(' + image + ')');

            /* Add Class */
            dropzone.parent().addClass('form-file-with-image');

        } else if (dropzone.parent().hasClass('file-pdf')) {
            var div = '<div class="form-file-link" data-pdf="' + image + '"><a target="_blank" href="' + image + '">View Anti-Counterfeiting Guide</a></div>';
            dropzone.find('.form-file-link').remove();
            dropzone.after(div);
            dropzone.parent().addClass('form-file-with-link');

        }
    }
}

/* Forms - File Dropzone */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsFileDropZone(input) {

    /* Get Input */
    input.parent().append('<div></div>')
    var dropzone = input.parent().find('div');

    /* Destroy Form Elements */
    input.parent().find('input[type=file]').remove();


    /* DropZone */
    dropzone.dropzone({
        url: input.data('url'),
        maxFiles: 1,
        init: function () {
            this.on('maxfilesexceeded', function (file) {
                this.removeAllFiles();
                this.addFile(file);
            });
        },
        success: function (file, response) {


            if (typeof response !== 'object') {
                try {
                    response = JSON.parse(response);
                } catch (e) {
                    console.error(e);
                    console.log(response);

                }
            }

            if (typeof (window.afterFileUploaded) === 'function') {

                if (typeof (response) === 'object' && response.hasOwnProperty('file')) {
                    ipcrimeFormsFileDropZoneImage(dropzone, response.file);
                }
                window.afterFileUploaded(file, response);
            }
        },
        error: function (file, response) {
            if (jQuery.type(response) === 'string') {
                var message = response;
            } else {
                var message = response.message;
            }
            if (message.toLowerCase().indexOf('<head') >= 0) {
                message = 'Error';
            }
            file.previewElement.classList.add("dz-error");
            _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                node = _ref[_i];
                _results.push(node.textContent = message);
            }
            return _results;
        },
        previewTemplate: '<div class="dz-preview dz-file-preview"><div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div><div class="dz-size" data-dz-size></div><img data-dz-thumbnail /></div><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><div class="dz-success-mark"><span>&#x2714;</span></div><div class="dz-error-mark"><span>&#x2716;</span></div><div class="dz-error-message"><span data-dz-errormessage></span></div></div>'
    });

    /* Image Test */
    var file = input.data('value');

    ipcrimeFormsFileDropZoneImage(dropzone, file);

}

/* Forms - File Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsFileInit() {
    /* Loop Inputs */
    jQuery('input.form-file').each(function (index) {

        /* Get Input */
        var input = jQuery(this);

        /* If Post URL */
        if (input.data('url') !== undefined && input.data('url') != '') {

            /* Template */
            input.wrap('<div></div>');

            /* Move Classes */
            input.parent().attr('class', input.attr('class'));
            input.removeClass();

            /* Label */
            ipcrimeFormsStyleLabel(input);

            /* Disabled */
            ipcrimeFormsStyleDisabled(input);

            /* Check DropZone Capability */
            if (jQuery('html').hasClass('platform-file-upload')) {

                /* DropZone */
                ipcrimeFormsFileDropZone(input);

            }

        }

    });

}
